import ValueX from '../types/ValueX';

export default class UsedX extends ValueX {
    static __className = 'UsedX';

    constructor(constructJson) {
        super(constructJson, 'used', 'UsedX');
    }
}
